import { FormBuilder, FormGroup, FormControl } from '@angular/forms';

export type AdministrationFormGroup = FormGroup<{
    administrationId: FormControl<number | null>;
}>;

export function createAdministrationFormGroup(formBuilder: FormBuilder): AdministrationFormGroup {
    return formBuilder.group({
        administrationId: new FormControl<number | null>(null),
    });
}
